import { VipAccessGate } from "@/components/VipAccessGate";

export const VipRoute = ({ access, children, language, onAccessResolved, vipEmail }) => {
  if (access) return children;

  return <VipAccessGate language={language} onAccessResolved={onAccessResolved} vipEmail={vipEmail} />;
};